<template>
  <div v-if="$route.query.type !== 'free'" class="quote-price-container">
    <div class="price-container">
      <div class="price-focused">
        <div v-if="$route.name !== 'quote-quoteid-annual'">
          {{ ($store.getters['quote/price'].total / 12) | toCurrency }}
          <span>monthly </span>
        </div>
        <div v-else>
          {{ $store.getters['quote/price'].total | toCurrency }}
          <span>annually</span>
        </div>
      </div>
      <div v-if="$route.name !== 'quote-quoteid-annual'" class="small-price">
        Annually
        {{ $store.getters['quote/price'].total | toCurrency }}
      </div>
      <div class="small-price">
        <span v-if="$store.getters['quote/addedHiplok'].dx.count">
          Hiplok DX
          {{ $store.getters['quote/addedHiplok'].dx.count }} x £30
        </span>
        <span v-if="$store.getters['quote/addedHiplok'].gold.count">
          Hiplok Gold
          {{ $store.getters['quote/addedHiplok'].gold.count }} x £40
        </span>
        <span v-if="$store.getters['quote/addedHiplok'].edx.count">
          Hiplok E-DX
          {{ $store.getters['quote/addedHiplok'].edx.count }} x £50
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Price',
}
</script>

<style lang="scss" scoped>
.quote-price-container {
  display: flex;
  align-items: center;
  justify-content: center;
}

.price-focused {
  font-size: 30px;
  color: $ps-primary;
  font-weight: 500;
  span {
    font-size: 15px;
  }
  @include tablet {
    font-size: 35px;
    span {
      font-size: 18px;
    }
  }
}
.small-price {
  font-size: 12px;
}
</style>
